const shadows = {
  small:
    '0px 2px 6px rgba(4, 9, 33, 0.1), 0px 2px 0px rgba(4, 9, 33, 0.05), 0px 0px 2px rgba(4, 9, 33, 0.03)'
};

export default shadows;
